/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Empty_RoomInputs */

const cs_enum_empty_room = /** @type {(inputs: Enum_Empty_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prázdná místnost`)
};

const en_enum_empty_room = /** @type {(inputs: Enum_Empty_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empty room`)
};

/**
* | output |
* | --- |
* | "Empty room" |
*
* @param {Enum_Empty_RoomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_empty_room = /** @type {((inputs?: Enum_Empty_RoomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Empty_RoomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_empty_room(inputs)
	return cs_enum_empty_room(inputs)
});